import { render, staticRenderFns } from "./TaskRow.vue?vue&type=template&id=6de6b6b4&scoped=true&lang=pug&"
import script from "./TaskRow.vue?vue&type=script&lang=js&"
export * from "./TaskRow.vue?vue&type=script&lang=js&"
import style0 from "./TaskRow.vue?vue&type=style&index=0&id=6de6b6b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de6b6b4",
  null
  
)

export default component.exports